"use client";

import type { AppEventTypes } from "@jace/insights";
import { CtaButton } from "./cta-button";

interface CTAProps {
	title?: string;
	description?: string;
	button?: React.ReactNode;
	placement: AppEventTypes["signup_click"]["placement"];
}

export function CTA({
	title = "Start saving 90% of your email time now.",
	description = "Let Jace do the boring stuff.",
	button,
	placement,
}: CTAProps) {
	return (
		<div className="mx-auto mt-20 max-w-7xl sm:mt-32 sm:px-6 lg:px-8">
			<div
				className="relative isolate overflow-hidden px-6 py-20 shadow-2xl sm:rounded-3xl sm:px-24 xl:py-24"
				style={{ background: "var(--jace-gradient)" }}
			>
				<h2 className="mx-auto max-w-xl text-center text-4xl font-semibold tracking-tight text-black sm:text-5xl">
					{title}
				</h2>
				<p className="mx-auto mt-6 max-w-lg text-center text-xl text-black">
					{description}
				</p>
				<div className="mt-10 flex justify-center">
					{button || <CtaButton intent="default" placement={placement} />}
				</div>
				<svg
					viewBox="0 0 1024 1024"
					aria-hidden="true"
					className="absolute left-1/2 top-1/2 -z-10 size-[64rem] -translate-x-1/2"
				>
					<circle
						r={512}
						cx={512}
						cy={512}
						fill="url(#759c1415-0410-454c-8f7c-9a820de03641)"
						fillOpacity="0.7"
					/>
					<defs>
						<radialGradient
							r={1}
							cx={0}
							cy={0}
							id="759c1415-0410-454c-8f7c-9a820de03641"
							gradientUnits="userSpaceOnUse"
							gradientTransform="translate(512 512) rotate(90) scale(512)"
						>
							<stop stopColor="var(--surface-highlight-a)" />
							<stop
								offset={1}
								stopColor="var(--surface-highlight-b)"
								stopOpacity={0}
							/>
						</radialGradient>
					</defs>
				</svg>
			</div>
		</div>
	);
}
